import React from 'react';

export default function ShipmentTableViewport({ children }) {
  return <div className="shipment-control-table-wrap" role="region" aria-label="Sevkiyat tablosu" tabIndex={0}>{children}</div>;
}
